/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfirmActionCommand } from '../models/ConfirmActionCommand';
import type { CountryEnum } from '../models/CountryEnum';
import type { CryptoCurrencyEnum } from '../models/CryptoCurrencyEnum';
import type { DeleteActionCommand } from '../models/DeleteActionCommand';
import type { FormEditDraftActionCommand } from '../models/FormEditDraftActionCommand';
import type { FormExchangeRatesActionCommand } from '../models/FormExchangeRatesActionCommand';
import type { NetTypeEnum } from '../models/NetTypeEnum';
import type { RejectActionCommand } from '../models/RejectActionCommand';
import type { ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum';
import type { ResponseData_Boolean } from '../models/ResponseData_Boolean';
import type { ReworkActionCommand } from '../models/ReworkActionCommand';
import type { SignActionCommand } from '../models/SignActionCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ActionService {
    /**
     * Список действий
     * @returns ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum OK
     * @throws ApiError
     */
    public static getApiV1ActionList(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/action/list',
        });
    }
    /**
     * Получить документ для действия
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiV1ActionDocument({
        id,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/action/{id}/document',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Действие подтвердить
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionConfirm({
        id,
        sign,
        requestBody,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        /**
         * Тело запроса
         */
        sign?: string,
        /**
         * Тело запроса
         */
        requestBody?: ConfirmActionCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/confirm',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Действие загрузить документ
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionUpload({
        id,
        sign,
        formData,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        /**
         * Тело запроса
         */
        sign?: string,
        formData?: {
            files?: Array<Blob>;
            readonly id?: string;
            comment?: string;
            readonly sign?: string;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/upload',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Действие загрузить подпись
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionSign({
        id,
        sign,
        requestBody,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        /**
         * Тело запроса
         */
        sign?: string,
        /**
         * Тело запроса
         */
        requestBody?: SignActionCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/sign',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Действие отклонить
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionReject({
        id,
        sign,
        requestBody,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        /**
         * Тело запроса
         */
        sign?: string,
        /**
         * Тело запроса
         */
        requestBody?: RejectActionCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/reject',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Действие переделать
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionRework({
        id,
        sign,
        requestBody,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        /**
         * Тело запроса
         */
        sign?: string,
        /**
         * Тело запроса
         */
        requestBody?: ReworkActionCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/rework',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Действие удалить
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionDelete({
        id,
        sign,
        requestBody,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        /**
         * Тело запроса
         */
        sign?: string,
        requestBody?: DeleteActionCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/delete',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Форма информации об агенте
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionFormAgentInfo({
        id,
        sign,
        formData,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        /**
         * Тело запроса
         */
        sign?: string,
        formData?: {
            /**
             * Комиссия уполномоченной организации в рублях.
             */
            commissionAuthorizedOrganizationRUB?: number;
            /**
             * Комиссия агента в рублях.
             */
            commissionAgentRUB?: number;
            /**
             * Криптоадрес кошелька агента.
             */
            agentCryptoAddress?: string;
            agentWalletNetId?: NetTypeEnum;
            cryptoCurrencyId?: CryptoCurrencyEnum;
            /**
             * Сумма криптовалюты
             */
            cryptoAmount?: number;
            /**
             * Наименование организация
             */
            organizationName?: string;
            senderCountryId?: CountryEnum;
            /**
             * Название банка
             */
            bankName?: string;
            /**
             * Документы сделки
             */
            files?: Array<Blob>;
            readonly id?: string;
            comment?: string;
            readonly sign?: string;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/form/agentInfo',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Форма обменных курсов
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionFormExchangeRates({
        id,
        sign,
        requestBody,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        /**
         * Тело запроса
         */
        sign?: string,
        /**
         * Тело запроса
         */
        requestBody?: FormExchangeRatesActionCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/form/exchangeRates',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Форма редактирования черновика
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionFormEditDraft({
        id,
        sign,
        requestBody,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        sign?: string,
        /**
         * Тело запроса
         */
        requestBody?: FormEditDraftActionCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/form/editDraft',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Форма редактирования заявки
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionFormEditApplication({
        id,
        sign,
        formData,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        sign?: string,
        formData?: {
            /**
             * Уникальный номер контракта.
             */
            contractUniqueNumber: string;
            /**
             * Номер внешнеторгового договора.
             */
            tradeAgreementNumber: string;
            /**
             * Адреса криптокошельков.
             */
            cryptoWalletAddresses?: Array<string>;
            /**
             * Новые файлы, загружаемые пользователем.
             */
            newFiles?: Array<Blob>;
            /**
             * Идентификаторы файлов, которые пользователь решил удалить.
             */
            removedFileIds?: Array<string>;
            readonly id?: string;
            comment?: string;
            readonly sign?: string;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/form/editApplication',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Форма информации о контрагенте
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionFormCounterpartyInfo({
        id,
        sign,
        formData,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        sign?: string,
        formData?: {
            /**
             * Комиссия уполномоченной организации в рублях.
             */
            commissionAuthorizedOrganizationRUB?: number;
            /**
             * Документы сделки
             */
            files?: Array<Blob>;
            readonly id?: string;
            comment?: string;
            readonly sign?: string;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/form/counterpartyInfo',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Форма кошельков, с которых будет осуществлять перевод ПЛ
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionFormProvideWallets({
        id,
        sign,
        formData,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        sign?: string,
        formData?: {
            /**
             * Криптокошелёк, куда планируется перевод.
             */
            walletAddress: string;
            readonly id?: string;
            comment?: string;
            readonly sign?: string;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/form/provideWallets',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Форма кошельков, с которых будет осуществлять перевод контрагент
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionFormWalletsWhichTransfer({
        id,
        sign,
        formData,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        sign?: string,
        formData?: {
            /**
             * Список криптокошельков, с которых планируется перевод.
             */
            walletAddresses: Array<string>;
            readonly id?: string;
            comment?: string;
            readonly sign?: string;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/form/walletsWhichTransfer',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Форма ввода суммы перевода фиата
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionFormTransferFiat({
        id,
        sign,
        formData,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        sign?: string,
        formData?: {
            /**
             * Полученная от клиента сумма (в рублях).
             */
            fiatAmount?: number;
            readonly id?: string;
            comment?: string;
            readonly sign?: string;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/form/transferFiat',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Форма ввода мдентификатора транзакции
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1ActionFormTransactionId({
        id,
        sign,
        formData,
    }: {
        /**
         * Идентификатор действия
         */
        id: string,
        sign?: string,
        formData?: {
            /**
             * Уникальный идентификатор криптовалютной транзакции
             */
            txId: Array<string>;
            readonly id?: string;
            comment?: string;
            readonly sign?: string;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/action/{id}/form/transactionId',
            path: {
                'id': id,
            },
            headers: {
                'sign': sign,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
